/**
 * This module provides a wrapper around firebase.
 */
import { FirebaseApp, initializeApp } from "firebase/app";
import * as auth from "firebase/auth";

import firebaseConfig from "../firebaseConfig";

let firebaseApp: FirebaseApp | null = null;
let firebaseAuth: auth.Auth | null = null;

/**
 * Initializes Firebase if not already initialized.
 * Safe to call multiple times.
 */
export function initializeFirebase() {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
    firebaseAuth = auth.getAuth(firebaseApp);
  }
}

export function getAuth() {
  initializeFirebase();
  return firebaseAuth!;
}

export type AuthUser = auth.User;

/**
 * Fetches the current user from firebase.
 * Returns null if we're not logged in.
 */
export function getCurrentUser(): AuthUser | null {
  initializeFirebase();
  return firebaseAuth?.currentUser || null;
}

/**
 * Listens for auth state changes from firebase
 */
export async function onAuthStateChanged(
  callback: (user: AuthUser | null) => Promise<void>,
): Promise<() => void> {
  initializeFirebase();
  return auth.onAuthStateChanged(getAuth(), callback);
}

export function signOut() {
  getAuth().signOut();
}
